var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClaim = function SvgClaim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92603 4.7268L4.99716 6.53905C5.28811 6.79362 5.31759 7.23586 5.06301 7.5268C4.80844 7.81775 4.3662 7.84723 4.07526 7.59265L0 4.0268L4.07526 0.460953C4.3662 0.206376 4.80844 0.235858 5.06301 0.526804C5.31759 0.817749 5.28811 1.25998 4.99716 1.51456L2.92603 3.3268H11C11.5523 3.3268 12 3.77452 12 4.3268V10.7268C12 11.2791 11.5523 11.7268 11 11.7268H6.76301C6.37642 11.7268 6.06301 11.4134 6.06301 11.0268C6.06301 10.6402 6.37641 10.3268 6.76301 10.3268H10.6V4.7268H2.92603Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClaim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/claim.2ab9aa1d.svg";
export { ForwardRef as ReactComponent };